let $ = jQuery;
require('jquery.formance');

class GiveValidator {

  constructor() {

    this.method = 'donate';
    this.version = '1.0';
    this.api_key = 'ric';
    this.api_secret = 'p81o4wlxbbtix0qkkg60';
    this.form_id = 1040;
    this.response_format = 'json';
    this.redirect_error = '/error/give';
    this.redirect_success = '/thank-you/give';
    this.$form = $("#yamlform-submission-give-form-form");

    if(this.$form.length) {
      this.currencyRegex = /^([0-9]*)?\.?([0-9]{2})*$/;
      this.$creditCardType = this.$form.find('#edit-credit-card-type');
      this.$creditCardNumber = this.$form.find('#edit-credit-card-number');
      this.$creditCardSecurityCode = this.$form.find('#edit-card-security-code');
      this.$email = this.$form.find('#edit-email');
      this.init();
    }
  }

  init() {
    this.handleEvents();
  }

  handleEvents() {
    this.$creditCardType.on('change', (e) => {
      this.handleCreditCardChange();
    });

    this.$form.on('submit', (e) => {
      e.preventDefault();
      this.handleFormSubmit();
    });
  }

  handleCreditCardChange() {
    let selected = this.$creditCardType.val();

    if(selected == 'amex') {
      this.$creditCardNumber.attr('data-inputmask-mask', '9999-999999-99999');
      this.$creditCardNumber.inputmask();
      this.$creditCardSecurityCode.attr('data-inputmask-mask', '9999');
      this.$creditCardSecurityCode.inputmask();
    } else {
      this.$creditCardNumber.attr('data-inputmask-mask', '9999-9999-9999-9999');
      this.$creditCardNumber.inputmask();
      this.$creditCardSecurityCode.attr('data-inputmask-mask', '999');
      this.$creditCardSecurityCode.inputmask();
    }
  }

  handleFormSubmit() {

    this.clearErrors();

    this.donation = $('input:radio[name="amount[radios]"]:checked').val();
    if(this.donation == '_other_') {
      this.donation = $('#edit-amount-other').val();
    }

    if(
      this.$creditCardNumber.formance('validate_credit_card_number') &&
      this.$creditCardSecurityCode.formance('validate_credit_card_cvc') &&
      this.$email.formance('validate_email') &&
      this.donation > 0 &&
      this.currencyRegex.test(this.donation)
    ) {
      this.handleValidForm();
    } else {
      this.handleNotValidForm();
    }
  }

  postSuccess(data) {
    console.log('postSuccess');
  }

  postError(xhr, status, err) {
    console.log('postError');
    console.log(status);
    console.log(err);
  }

  handleValidForm() {

    let email = this.$email.val();
    let card_cvv = this.$creditCardSecurityCode.val();
    let card_number = this.$creditCardNumber.val().replace(/-/g, '');

    let nameFirst = $('#edit-name-first').val();
    let nameLast = $('#edit-name-last').val();
    let street = $('#edit-address-address').val();
    let city = $('#edit-address-city').val();
    let state = $('#edit-address-state-province').val();
    let zip = $('#edit-address-postal-code').val();

    let url = `https://webservices.cluster3.convio.net/1.0/ric`
      + `?method=${this.method}`
      + `&api_key=${this.api_key}`
      + `&v=${this.version}`
      + `&error_redirect=${this.redirect_error}`
      + `&success_redirect=${this.redirect_success}`
      + `&response_format=${this.response_format}`
      + `&donor.email=${email}`
      + `&form_id=${this.form_id}`
      + `&card_cvv=${card_cvv}`
      + `&card_number=${card_number}`
      + `&billing.name.first=${nameFirst}`
      + `&billing.name.last=${nameLast}`
      + `&billing.address.street1=${street}`
      + `&billing.address.city=${city}`
      + `&billing.address.state=${state}`
      + `&billing.address.zip=${zip}`
      + `&level_id=${this.donation}`;

    $.ajax({
      type: 'POST',
      url: url,
      // data: data,
      success: (data) => {
        this.postSuccess(data);
      },
      error: (xhr, status, err) => {
        this.postError(xhr, status, err);
      }
    });

  }

  clearErrors() {
    $('.validation-error').remove();
  }

  placeError(selector, msg) {
    let $target = $(selector);
    $target.find('label').first().before(`<div class="error validation-error">${msg}</div>`);
    let top = $target.find('.validation-error').offset().top - 200;
    $(window).scrollTop(top);
  }

  handleNotValidForm() {

    // Check errors from bottom to top so that the document will be scrolled to the top most error

    if(this.$creditCardSecurityCode.formance('validate_credit_card_cvc') == false) {
      this.placeError('.js-form-item-card-security-code', 'Invalid Card Security Code');
    }

    if(this.$creditCardNumber.formance('validate_credit_card_number') == false) {
      this.placeError('.js-form-item-credit-card-number', 'Invalid Credit Card Number');
    }

    if(this.$email.formance('validate_email') == false) {
      this.placeError('.js-form-item-email', 'Invalid Email');
    }

    if(this.donation > 0 == false || this.currencyRegex.test(this.donation) == false) {
      this.placeError('.js-form-type-yamlform-radios-other', 'Invalid Donation Amount');
    }

  }
}

module.exports = {
  attach: function(context, settings) {
    let giveValidator = new GiveValidator();
  }
}
